import type { ApiEnvelope } from "@examora/shared/api/envelope";

/**
 * Safely parses a fetch Response as our API's JSON envelope. Defense in
 * depth: the backend's global error handler guarantees every /api/v1
 * response is the envelope, but a proxy or network edge case could still
 * hand back something else — this degrades to a generic error instead of
 * throwing, so the UI never crashes on a malformed response.
 */
export async function safeParseApiResponse<T>(response: Response): Promise<ApiEnvelope<T>> {
  const text = await response.text();

  if (!text) {
    return {
      ok: false,
      error: { message: "Empty response from server.", code: "EMPTY_RESPONSE" },
    };
  }

  try {
    return JSON.parse(text) as ApiEnvelope<T>;
  } catch {
    return {
      ok: false,
      error: { message: "Received an invalid response from server.", code: "INVALID_JSON" },
    };
  }
}
